import { Link } from "react-router-dom";

interface Props {
  eyebrow: string;
  title: string;
  desc?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeader({ eyebrow, title, desc, linkTo, linkLabel = "查看全部" }: Props) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
          <i className="ri-leaf-line text-sm" aria-hidden="true" />
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-2 max-w-xl text-sm leading-6 text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          className="group inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 bg-background-100 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          {linkLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}